import {AutoComplete, Button, Form, Input, Select, Spin} from "antd";
import BirthdateInput from "../../core/components/BirthdateInput";
import {useEffect, useRef, useState} from "react";
import {t} from "i18next";
import ApiService from "../../core/service/api-service";
import { matchesSearch } from "../../core/utils/text-search";

const SEARCH_DEBOUNCE_MS = 300;
const MIN_SEARCH_LENGTH = 2;

export default function StudyCreateModal({onSuccess})
{
    const [hospitals, setHospitals] = useState([]);
    const [modalities, setModalities] = useState([])
    const [patientOptions, setPatientOptions] = useState([]);
    const [searching, setSearching] = useState(false);
    const formRef = useRef();
    const searchTimer = useRef();

    const onFinish = async (formData) => {
        const res = await ApiService.Dicom.UploadDicom(formData)
        if(res.success)
        {
            onSuccess && onSuccess()
        }
    }

    // Hasta kimliği yazıldıkça DB'de ön ek araması yapar; seçilen hastanın bilgileri forma dolar.
    const searchPatients = (search) => {
        clearTimeout(searchTimer.current);

        if (search.length < MIN_SEARCH_LENGTH)
        {
            setPatientOptions([]);
            setSearching(false);
            return;
        }

        setSearching(true);
        searchTimer.current = setTimeout(async () => {
            const res = await ApiService.Patient.SearchByDicomPatientId(search);
            setSearching(false);

            if (!res.success)
            {
                setPatientOptions([]);
                return;
            }

            setPatientOptions(res.data.map(patient => ({
                value: patient.dicomPatientId,
                label: (
                    <div>
                        <b>{patient.dicomPatientId}</b>
                        <span style={{marginLeft: 8}}>{patient.name}</span>
                        {patient.birthdate && (
                            <span style={{marginLeft: 8, color: '#8c8c8c'}}>{patient.birthdate}</span>
                        )}
                    </div>
                ),
                patient
            })));
        }, SEARCH_DEBOUNCE_MS);
    }

    const onPatientSelect = (_, option) => {
        const patient = option.patient;

        formRef.current.setFieldsValue({
            patientName: patient.name,
            gender: patient.gender ? patient.gender.toUpperCase() : undefined,
            // Patient.Birthdate DateOnly → 'YYYY-MM-DD'; BirthdateInput aynı biçimi bekler.
            birthdate: patient.birthdate ?? null
        });
    }

    useEffect(() => () => clearTimeout(searchTimer.current), []);

    useEffect(async () => {
        const res = await ApiService.UserManager.GetHospitalsOfUser();
        if(res.success)
        {
            setHospitals(res.data)
        }
    }, [])

    useEffect(async () => {
        const res = await ApiService.Modality.GetList();
        if(res.success)
        {
            setModalities(res.data)
        }
    }, [])

    return (
        <>
            <Form
                layout={'vertical'}
                ref={formRef}
                onFinish={onFinish}
            >
                <Form.Item
                    label={t('Hospital')}
                    name={'hospitalId'}
                    rules={[{required: true}]}
                >
                    <Select
                        showSearch={true}
                        filterOption={(input, option) => {
                            return matchesSearch(option?.children, input)
                        }}
                    >
                        {hospitals.map(h => {
                            return (
                                <Select.Option
                                    key={h.id}
                                    value={h.id}
                                >
                                    {h.name}
                                </Select.Option>
                            )
                        })}
                    </Select>
                </Form.Item>

                <Form.Item
                    label={t('Patient Id')}
                    name={'dicomPatientId'}
                    rules={[{required: true}]}
                >
                    <AutoComplete
                        options={patientOptions}
                        onSearch={searchPatients}
                        onSelect={onPatientSelect}
                        notFoundContent={searching ? <Spin size={'small'} /> : null}
                    >
                        <Input placeholder={t('Type to search existing patients')} />
                    </AutoComplete>
                </Form.Item>

                <Form.Item
                    label={t('Patient Name')}
                    name={'patientName'}
                    rules={[{required: true}]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label={t('Birthdate')}
                    name={'birthdate'}
                    rules={[{required: true, message: t('Please enter a valid date')}]}
                >
                    <BirthdateInput />
                </Form.Item>

                <Form.Item
                    label={t('Gender')}
                    name={'gender'}
                    rules={[{required: true}]}
                >
                    <Select>
                        <Select.Option value={'F'}>{t('F')}</Select.Option>
                        <Select.Option value={'M'}>{t('M')}</Select.Option>
                        <Select.Option value={'O'}>{t('O')}</Select.Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    label={t('Modality')}
                    name={'modalityId'}
                    rules={[{required: true}]}
                >
                    <Select>
                        {modalities.map(m => {
                            return (
                                <Select.Option key={m.id} value={m.id}>
                                    {m.name}
                                </Select.Option>
                            )
                        })}
                    </Select>
                </Form.Item>

                <Form.Item
                    label={t('Accession Number')}
                    name={'accessionNumber'}
                    rules={[{required: true}]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label={t('Study Description')}
                    name={'studyDescription'}
                    rules={[{required: true}]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                >
                    <Button type={'primary'} htmlType={'submit'}>{t('Save')}</Button>
                </Form.Item>

            </Form>
        </>
    )
}
